import { Search, MessageCircleQuestion } from "lucide-react";
import { Button } from "@/components/ui/PageHeader";
import type { AssistanceResponse } from "@/api/composer";

export function AssistanceGuidancePanel({ guidance, disabled, onChoose }: {
  guidance: AssistanceResponse["guidance"];
  disabled: boolean;
  onChoose: (search: AssistanceResponse["guidance"]["searches"][number]) => void;
}) {
  if (!guidance.questions.length && !guidance.searches.length) return null;
  return <section className="space-y-2 rounded-lg border p-3" aria-label="Suggested next steps">
    <h4 className="font-semibold">Suggested next steps</h4>
    <p className="text-xs">These are model suggestions, not facts or completed searches. Check the wording and location before continuing.</p>
    {guidance.questions.map(question => <p className="flex gap-2" key={question}>
      <MessageCircleQuestion className="h-4 w-4 shrink-0" />{question}</p>)}
    {guidance.searches.map((search, index) => <div className="rounded border p-2" key={index}>
      <p>{search.query}</p><p className="text-xs">{search.features.join(", ")} · {[search.city, search.state].filter(Boolean).join(", ") || "No location filter"}</p>
      <Button size="sm" variant="secondary" disabled={disabled} onClick={() => onChoose(search)}>
        <Search className="mr-1 h-4 w-4" />Edit search proposal</Button>
    </div>)}
    <p className="text-xs">Selecting a proposal only fills the search controls. No request starts until you confirm.</p>
  </section>;
}
